import React, { useEffect, useRef, useState } from "react";
import config from "../config";
import Notification from "./Notification";
const Header = ({
  isMobile,
  setIsSidebarOpen,
  onViewProfile,
  onOpenSettings,
  onLogout,
  onOpenCreate,
}) => {
  const menuRef = useRef(null);

  const [admin, setAdmin] = useState(null);
  const [avatar, setAvatar] = useState(null);
  const [openMenu, setOpenMenu] = useState(false);

  /* LOAD ADMIN */
  useEffect(() => {
    const stored = localStorage.getItem("admin");
    if (stored) setAdmin(JSON.parse(stored));
  }, []);

  /* LOAD PROFILE PIC */
  useEffect(() => {
    if (!admin?.username) return;

const fetchAvatar = async () => {
  try {
    const res = await fetch(
      `${config.API_BASE_URL}/Admin/get-profile-picture/${admin.username}`
    );
    if (!res.ok || res.status === 204) return; // walang picture, skip lang
    const blob = await res.blob();
    setAvatar(URL.createObjectURL(blob));
  } catch {
    // silent
  }
};
    fetchAvatar();
  }, [admin?.username]);

  /* CLOSE ON OUTSIDE CLICK */
  useEffect(() => {
    const handler = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setOpenMenu(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const closeMenu = () => setOpenMenu(false);

  return (
    <div className="bg-gray-800 border-b border-gray-700 sticky top-0 z-20">
      <div className="px-4 py-3 md:px-6 md:py-4">

        {/* TOP ROW */}
        <div className="flex justify-between items-center gap-2">

          {/* LEFT: hamburger + greeting */}
          <div className="flex items-center gap-3 min-w-0">
            {isMobile && (
              <button
                onClick={() => setIsSidebarOpen(true)}
                className="p-2 hover:bg-gray-700 rounded-lg flex-shrink-0"
              >
                <svg className="w-5 h-5 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                </svg>
              </button>
            )}

            <div className="min-w-0">
              <h2 className="text-base sm:text-xl md:text-2xl font-bold text-white truncate">
                Welcome back, <span className="text-indigo-400">{admin?.fullNames || "Admin"}</span>!
              </h2>
              <p className="text-xs text-gray-400 hidden sm:block">
                Have a great day at work
              </p>
            </div>
          </div>

          {/* RIGHT: create (sm+), notifications, avatar */}
          <div className="flex items-center gap-2 flex-shrink-0">

            {/* Create button — hidden on xs, visible sm+ */}
            <button
              onClick={onOpenCreate}
              className="hidden sm:flex items-center gap-1 px-3 py-1.5 md:px-4 md:py-2
                bg-indigo-600 hover:bg-indigo-700 text-white text-sm font-semibold rounded-lg shadow transition"
            >
              <span className="text-base leading-none">+</span>
              <span>Create</span>
            </button>

            {/* Notifications */}
            <button className="p-2 hover:bg-gray-700 rounded-lg relative">
              <Notification />

            </button>

            {/* AVATAR */}
            <div className="relative" ref={menuRef}>
              <button
                onClick={() => setOpenMenu(!openMenu)}
                className="w-9 h-9 md:w-10 md:h-10 rounded-full overflow-hidden border-2 border-indigo-500 hover:scale-105 transition flex-shrink-0"
              >
                {avatar ? (
                  <img src={avatar} alt="avatar" className="w-full h-full object-cover" />
                ) : (
                  <div className="w-full h-full bg-gradient-to-r from-blue-500 to-purple-600 flex items-center justify-center text-white font-bold text-sm">
                    {admin?.fullNames?.[0] || "A"}
                  </div>
                )}
              </button>

              {/* DROPDOWN MENU */}
              {openMenu && (
                <div className="absolute right-0 mt-3 w-52 bg-gray-800 border border-gray-700 rounded-xl shadow-xl overflow-hidden z-30">
                  {/* Admin info */}
                  <div className="px-4 py-3 border-b border-gray-700">
                    <p className="text-sm font-semibold text-white truncate">
                      {admin?.fullNames || "Admin"}
                    </p>
                    <p className="text-xs text-gray-400 truncate">@{admin?.username}</p>
                  </div>

                  <MenuItem label="View Profile" onClick={() => { closeMenu(); onViewProfile(); }} />
                  <MenuItem label="Settings" onClick={() => { closeMenu(); onOpenSettings(); }} />

                  {/* Create — only shown in dropdown on mobile */}
                  {isMobile && (
                    <MenuItem
                      label="+ Create"
                      onClick={() => { closeMenu(); onOpenCreate(); }}
                    />
                  )}

                  <div className="border-t border-gray-700">
                    {/* Logout — always in dropdown, main logout path on mobile */}
                    <MenuItem
                      label="Logout"
                      danger
                      onClick={() => { closeMenu(); onLogout(); }}
                    />
                  </div>
                </div>
              )}
            </div>

          </div>
        </div>

        {/* BOTTOM ROW — full-width Create on xs only */}
        <div className="mt-2 sm:hidden">
          <button
            onClick={onOpenCreate}
            className="w-full flex items-center justify-center gap-1 px-4 py-2
              bg-indigo-600 hover:bg-indigo-700 text-white text-sm font-semibold rounded-lg shadow transition"
          >
            <span className="text-base leading-none">+</span>
            <span>Create</span>
          </button>
        </div>

      </div>
    </div>
  );
};

/* MENU ITEM */
const MenuItem = ({ label, onClick, danger }) => (
  <button
    onClick={onClick}
    className={`w-full text-left px-4 py-2.5 text-sm transition hover:bg-gray-700
      ${danger ? "text-red-400 hover:text-red-300" : "text-gray-200"}`}
  >
    {label}
  </button>
);

export default Header;